import { ServerErrorResponse } from 'const';
import { ServerError } from 'core';

function isObjectWithProperty(
  param: unknown,
  property: string
): param is { [property: string]: unknown } {
  return typeof param === 'object' && param !== null && property in param;
}

function isErrorResponse(serverResponse: unknown): serverResponse is ServerErrorResponse {
  return (
    isObjectWithProperty(serverResponse, 'data') &&
    isObjectWithProperty(serverResponse.data, 'error')
  );
}

export function parseServerErrors(serverResponse: unknown): ServerError[] {
  if (isErrorResponse(serverResponse)) {
    return serverResponse.data.error;
  }

  return [];
}
